import { render, staticRenderFns } from "./DaysBackApproval.vue?vue&type=template&id=4e423368"
import script from "./DaysBackApproval.vue?vue&type=script&lang=js"
export * from "./DaysBackApproval.vue?vue&type=script&lang=js"
import style0 from "./DaysBackApproval.vue?vue&type=style&index=0&id=4e423368&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports